import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import LeadCaptureConfirmation from '@components/LeadCaptureForm/LeadCaptureConfirmation';
import DialogHeader from '@shared/components/overlays/DialogHeader/DialogHeader';

export interface LeadCaptureConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  leadId: string;
  actionLabel?: string;
  onAction?: () => void;
}

const LeadCaptureConfirmationDialog = ({
  open,
  onClose,
  leadId,
  actionLabel,
  onAction,
}: LeadCaptureConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      data-backdrop-variant="blurred"
      className="lead-capture-confirmation-dialog"
    >
      <DialogHeader title="" onClose={onClose} variant="title.dialogCondensed" noBgColor />

      <DialogContent>
        <LeadCaptureConfirmation onClose={onClose} leadId={leadId} actionLabel={actionLabel} onAction={onAction} />
      </DialogContent>
    </Dialog>
  );
};

export default LeadCaptureConfirmationDialog;
